
























import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { Style } from "@/services/styles/types";
import { WayfinderCSS } from "@/services/wayfinder/types";

@Component
export default class EnglishKeyboard extends Vue {
    @Prop() private wayfinderCss!: WayfinderCSS;

    lettersFirstRow = ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"];
    lettersSecondRow = ["a", "s", "d", "f", "g", "h", "j", "k", "l"];
    lettersThirdRow = ["z", "x", "c", "v", "b", "n", "m"];
    showNumbers: boolean = false;
    capital: boolean = false;

    write(char: string) {
        this.$emit("write", char);
    }

    setCapital() {
        this.capital = !this.capital;
        this.write("capital");
    }

    switchKeyboard() {
        this.showNumbers = !this.showNumbers;
        this.$emit("switchKeyboard", this.showNumbers);
    }

    // computed
    get styleModel() {
        return this.wayfinderCss ? this.wayfinderCss : {} as WayfinderCSS;
    }
}
